import React, { useEffect, useState } from "react";
import Portal from "../Portal";
import ImageViewModal from "./ImageViewModal";
import ImageForm from "./ImageForm";
import ReactTooltip from "react-tooltip";
import ConfirmationModal from "../ConfirmationModal";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import noImage from "../../../../assets/img/no-image-available.png";
import ImageAnalyzeViewModal from "../../../images/components/ImageViewModal";
import { checkPermission } from "../../../../config/utils";
import { useSelector } from "react-redux";
import { getCapitalRequestLabel } from "../../../../utils/capitalRequestLabel";

export const ImageBand = ({
    basicDetails,
    updateImage,
    deleteImage,
    hasEdit,
    getAllImagesResponse,
    className = "",
    refreshImageList,
    isSurveyAssetView = false,
    isImagePreview = false,
    onZoomIn,
    onZoomOut,
    onReset,
    onViewImage = false,
    isZoom,
    isModalView = false,
    hasCaptionEdit = true,
    isAnalyseViewModal = false,
    isMobRecom = false
}) => {
    const [showImageModal, setImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(basicDetails?.image);
    const [imageList, setImageList] = useState([]);
    const [showImageEditModal, setImageEditModal] = useState(false);
    const [showDeleteConfirmation, setDeleteConfirmation] = useState(false);
    const [isZooming, setIsZooming] = useState(false);

    useEffect(() => {
        if (onViewImage) {
            onViewImage(() => setImageModal(true));
        }
    }, [onViewImage]);

    useEffect(() => {
        if (getAllImagesResponse?.images?.length) {
            const images = [...getAllImagesResponse.images];
            const defaultImageItem = images.find(item => item?.default_image === true);
            const index = images.indexOf(defaultImageItem);
            if (index > -1) {
                images.splice(index, 1);
                images.unshift(defaultImageItem);
            }
            setSelectedImage(prev => images.find(item => item?.id === prev?.id) || defaultImageItem || images[0]);
            setImageList(images);
        } else {
            setSelectedImage({});
            setImageList([]);
        }
    }, [getAllImagesResponse]);

    const handleNext = id => {
        let current_index = imageList?.findIndex(item => item?.id === id);
        let selectedImage = imageList[current_index + 1];
        setSelectedImage(selectedImage);
    };
    const handlePrev = id => {
        let current_index = imageList?.findIndex(item => item?.id === id);
        let selectedImage = imageList[current_index - 1];
        setSelectedImage(selectedImage);
    };

    const miscellaneous = useSelector(state => state.projectReducer?.getProjectByIdResponse?.miscellaneous);
    const isCR = basicDetails?.infrastructure_request === "yes";
    const entityLabel = isCR ? getCapitalRequestLabel(miscellaneous) : "recommendation";

    const renderDeleteConfirmationModal = () => {
        if (!showDeleteConfirmation) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to remove this image from this ${entityLabel}?`}
                        message={"This action cannot be reverted, are you sure that you need to remove this image?"}
                        onNo={() => setDeleteConfirmation(false)}
                        onYes={() => handleDeleteImage(showDeleteConfirmation)}
                    />
                }
                onCancel={() => setDeleteConfirmation(false)}
            />
        );
    };

    const handleDeleteImage = id => {
        setDeleteConfirmation(false);
        setImageList(imageList.filter(item => item.id === id));
        setImageEditModal(false);
        setImageModal(false);
        deleteImage(id);
    };
    const handleZoomChange = ref => {
        if (typeof ref?.scale === "number") {
            if (ref.scale > 1 && !isZooming) {
                setTimeout(() => {
                    setIsZooming(true);
                }, 200);
            } else if (ref.scale === 1 && isZooming) {
                setIsZooming(false);
            }
        }
    };

    const { is_edited = "", s3_eimage_key, s3_image_key, updated_at = "" } = selectedImage?.master_image || selectedImage || {};

    const imageThumbnailUrl = is_edited ? s3_eimage_key : s3_image_key;

    let extraProps = {
        onZoomChange: state => {
            handleZoomChange(state);
        }
    };

    return (
        <>
            {imageList?.length > 1 && (
                <div>
                    <button
                        className={`arrow-butn-left ${imageList[0]?.id === selectedImage?.id ? "cursor-diabled" : ""}`}
                        disabled={imageList[0]?.id === selectedImage?.id}
                        onClick={() => handlePrev(selectedImage?.id)}
                        data-place="top"
                        data-effect="solid"
                        data-tip="Previous"
                        data-for="image-view-modal"
                        type="button"
                    >
                        <i class="fas fa-chevron-left"></i>
                    </button>

                    <button
                        className={`arrow-butn-right ${selectedImage?.id === imageList[imageList.length - 1]?.id ? "cursor-diabled" : ""}`}
                        disabled={selectedImage?.id === imageList[imageList.length - 1]?.id}
                        onClick={() => handleNext(selectedImage?.id)}
                        data-place="top"
                        data-effect="solid"
                        data-tip="Next"
                        data-for="image-view-modal"
                        type="button"
                    >
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            )}
            <div
                className={`details-img-block ${imageThumbnailUrl ? "cursor-hand" : ""} ${className}`}
                onClick={() => (imageThumbnailUrl && !isImagePreview ? setImageModal(true) : null)}
            >
                {imageThumbnailUrl ? (
                    <>
                        <ReactTooltip id="image-caption" backgroundColor="#007bff" />

                        {isImagePreview ? (
                            <TransformWrapper key={`${imageThumbnailUrl} + ${isModalView ? "modal" : "band"}`} defaultScale={1} {...extraProps}>
                                {({ zoomIn, zoomOut, resetTransform, ...rest }) => {
                                    zoomIn && onZoomIn(zoomIn);
                                    zoomOut && onZoomOut(zoomOut);
                                    resetTransform && onReset(resetTransform);
                                    isZooming && isZoom(isZooming);
                                    return (
                                        <div className={`recom-preview not-draggable ${isModalView ? "modal-view" : ""}`}>
                                            <TransformComponent>
                                                <img src={imageThumbnailUrl} alt="Zoomable" />
                                            </TransformComponent>
                                        </div>
                                    );
                                }}
                            </TransformWrapper>
                        ) : (
                            <img src={`${imageThumbnailUrl}`} alt="" />
                        )}
                        {!isImagePreview && (
                            <div
                                className="sub-cont-img-sec"
                                data-place="bottom"
                                data-effect="solid"
                                data-tip={selectedImage?.description || selectedImage?.caption || ""}
                                data-for="image-caption"
                            >
                                <h4>{selectedImage?.description || selectedImage?.caption || "-"}</h4>
                            </div>
                        )}
                    </>
                ) : (
                    <img src={noImage} alt="" />
                )}
            </div>
            {showImageModal && imageList?.length ? (
                <Portal
                    body={
                        isAnalyseViewModal ? (
                            <ImageAnalyzeViewModal
                                imageList={imageList}
                                selectedImg={selectedImage}
                                handleNext={handleNext}
                                handlePrev={handlePrev}
                                onCancel={() => setImageModal(false)}
                                hasNextPrev={imageList.length > 1}
                                isSurveyAssetImage={!isMobRecom}
                                hasCaptionEdit={false}
                                isMobRecom={isMobRecom}
                                handleEdit={() => setImageEditModal(true)}
                                hasEdit={hasEdit}
                            />
                        ) : (
                            <ImageViewModal
                                imageList={imageList}
                                image={selectedImage}
                                handleNext={handleNext}
                                handlePrev={handlePrev}
                                onCancel={() => setImageModal(false)}
                                hasEditButton={hasEdit}
                                hasNextPrev={imageList.length > 1}
                                handleEdit={() => setImageEditModal(true)}
                                isRecommendationView={true}
                                isSurveyAssetView={isSurveyAssetView}
                                hasCaptionEdit={hasCaptionEdit}
                                hasExport={checkPermission("forms", "image_management", "export")}
                            />
                        )
                    }
                    onCancel={() => setImageModal(false)}
                />
            ) : null}
            {showImageEditModal && (
                <Portal
                    body={
                        <ImageForm
                            imageList={imageList}
                            images={selectedImage}
                            handleNext={handleNext}
                            handlePrev={handlePrev}
                            updateImage={updateImage}
                            handleDelete={id => setDeleteConfirmation(id)}
                            onCancel={() => setImageEditModal(false)}
                            isRecommendationView={true}
                            hasNextPrev={imageList.length > 1}
                            refreshImageList={() => {
                                setImageModal(false);
                                refreshImageList && refreshImageList();
                            }}
                            updateImagePreview={updateImage}
                            isImagePreview={isImagePreview}
                        />
                    }
                    onCancel={() => setImageEditModal(false)}
                />
            )}
            {renderDeleteConfirmationModal()}
        </>
    );
};
